import { Buffer as NodeBuffer } from 'buffer';
if (typeof global !== 'undefined') {
    global.Buffer = global.Buffer || NodeBuffer;
}
else if (typeof window !== 'undefined') {
    window.Buffer = window.Buffer || NodeBuffer;
    window.global = window.global || window;
}
else {
    self.Buffer = self.Buffer || NodeBuffer;
    self.global = self.global || self;
}
import { OnRampAsset, OnRampProvider, OnRampPurchaseStatus, } from '@usecapsule/user-management-client';
export { OnRampAsset, OnRampProvider, OnRampPurchaseStatus };
export const is2FAEnabled = false;
export var Environment;
(function (Environment) {
    // Internal Environments
    Environment["DEV"] = "DEV";
    Environment["SANDBOX"] = "SANDBOX";
    Environment["BETA"] = "BETA";
    Environment["PROD"] = "PROD";
    // Customer-Facing Environments
    // NOTE: these resolve to the corresponding internal environments for convenience
    Environment["DEVELOPMENT"] = "BETA";
    Environment["PRODUCTION"] = "PROD";
})(Environment || (Environment = {}));
export var OAuthMethod;
(function (OAuthMethod) {
    OAuthMethod["GOOGLE"] = "GOOGLE";
    OAuthMethod["TWITTER"] = "TWITTER";
    OAuthMethod["APPLE"] = "APPLE";
    OAuthMethod["DISCORD"] = "DISCORD";
    OAuthMethod["FACEBOOK"] = "FACEBOOK";
    OAuthMethod["FARCASTER"] = "FARCASTER";
})(OAuthMethod || (OAuthMethod = {}));
export const OnRampProviderMap = {
    STRIPE: OnRampProvider.STRIPE,
    stripe: OnRampProvider.STRIPE,
    RAMP: OnRampProvider.RAMP,
    ramp: OnRampProvider.RAMP,
};
export const OnRampAssetMap = {
    eth: OnRampAsset.ETHEREUM,
    ETH: OnRampAsset.ETHEREUM,
    ethereum: OnRampAsset.ETHEREUM,
    ETHEREUM: OnRampAsset.ETHEREUM,
    // sol: OnRampAsset.SOLANA,
    // SOL: OnRampAsset.SOLANA,
    // solana: OnRampAsset.SOLANA,
    // SOLANA: OnRampAsset.SOLANA,
    usdc: OnRampAsset.USDC,
    USDC: OnRampAsset.USDC,
};
export const OnRampProviderAssetMap = [
    // Production mode
    {
        [OnRampProvider.STRIPE]: {
            [OnRampAsset.ETHEREUM]: 'eth',
            // [OnRampAsset.SOLANA]: 'sol',
            [OnRampAsset.USDC]: 'usdc',
        },
        [OnRampProvider.RAMP]: {
            [OnRampAsset.ETHEREUM]: 'ETH_ETH',
            // [OnRampAsset.SOLANA]: 'SOL_SOL',
            [OnRampAsset.USDC]: 'ETH_USDC',
        },
    },
    // Test mode
    {
        [OnRampProvider.STRIPE]: {
            [OnRampAsset.ETHEREUM]: 'eth',
            // [OnRampAsset.SOLANA]: 'sol',
            [OnRampAsset.USDC]: 'usdc',
        },
        [OnRampProvider.RAMP]: {
            [OnRampAsset.ETHEREUM]: 'SEPOLIA_ETH',
            [OnRampAsset.USDC]: 'SEPOLIA_USDC',
        },
    },
];
export var OnRampMethod;
(function (OnRampMethod) {
    OnRampMethod["ACH"] = "ACH";
    OnRampMethod["DEBIT"] = "Debit";
    OnRampMethod["CREDIT"] = "Credit";
    OnRampMethod["APPLE_PAY"] = "Apple Pay";
})(OnRampMethod || (OnRampMethod = {}));
export function getProvider(key) {
    return OnRampProviderMap[key];
}
export function getAsset(key) {
    return OnRampAssetMap[key];
}
export function getProviderAsset(provider, asset, testMode = false) {
    return OnRampProviderAssetMap[Number(testMode)][getProvider(provider)][getAsset(asset)];
}
export function getProviderAssetInverse(provider, asset, testMode) {
    const match = Object.entries(OnRampProviderAssetMap[Number(testMode)][getProvider(provider)]).find(([, theirAssetCode]) => asset === theirAssetCode);
    return match ? match[0] : undefined;
}
export function getPortalDomain(env) {
    switch (env) {
        case Environment.DEV:
            return 'localhost';
        case Environment.SANDBOX:
            return 'app.sandbox.usecapsule.com';
        case Environment.BETA:
            return 'app.beta.usecapsule.com';
        case Environment.PROD:
            return 'app.usecapsule.com';
        default:
            throw new Error(`env: ${env} not supported`);
    }
}
export function getPortalBaseURL({ env }, useLocalIp) {
    const domain = getPortalDomain(env);
    if (env === Environment.DEV) {
        if (useLocalIp) {
            return `http://127.0.0.1:3003`;
        }
        return `http://${domain}:3003`;
    }
    return `https://${domain}`;
}
